import React from 'react';
import { Link } from 'react-router-dom';
import { Volleyball, Loader2 } from 'lucide-react';
import { formatDate, formatScore } from '../../lib/beachvision-utils';
import { StatusBadge } from './StatusBadge';

/**
 * Session row with video-style thumb, metadata, and status chip.
 */
export function SessionCard({ id, analysis_id, title, status, recorded_at, overall_score }) {
  const to =
    status === 'complete'
      ? `/analysis/${analysis_id || id}/takeaways/`
      : `/sessions/${id}/`;

  const badge = () => {
    if (status === 'complete') {
      return (
        <StatusBadge variant="complete" outline>
          AI scored
          {overall_score != null ? ` · ${formatScore(overall_score)}` : ''}
        </StatusBadge>
      );
    }
    if (status === 'failed') {
      return <StatusBadge variant="failed">Failed</StatusBadge>;
    }
    if (status === 'processing') {
      return (
        <StatusBadge variant="processing" showSpinner outline>
          Processing
        </StatusBadge>
      );
    }
    return (
      <StatusBadge variant="pending" showSpinner outline>
        Pending
      </StatusBadge>
    );
  };

  return (
    <Link
      to={to}
      className="w-full text-left rounded-2xl bg-beachvision-surface-low flex overflow-hidden min-h-[100px] hover:brightness-110 transition-[filter]"
    >
      <div className="relative w-24 shrink-0 bg-gradient-to-br from-beachvision-coral/35 to-beachvision-teal/25">
        <span className="absolute bottom-2 left-2 rounded bg-black/70 px-1.5 py-0.5 text-xs text-white font-mono">
          —
        </span>
        <span className="absolute inset-0 flex items-center justify-center">
          <Volleyball className="h-10 w-10 text-white/85" aria-hidden />
        </span>
      </div>
      <div className="flex-1 min-w-0 p-4 flex flex-col justify-center gap-1">
        <div className="flex items-start justify-between gap-2">
          <p className="text-xs text-beachvision-muted">
            {formatDate(recorded_at)}
            <span className="text-beachvision-muted"> · </span>
            <span className="text-beachvision-muted/80">Session</span>
          </p>
          <span className="shrink-0">{badge()}</span>
        </div>
        <h3 className="font-display font-bold text-white truncate text-base">{title}</h3>
        {status === 'complete' && overall_score != null ? (
          <p className="text-xs text-beachvision-teal flex items-center gap-1 mt-0.5">
            <span className="inline-block w-1 h-1 rounded-full bg-beachvision-teal" />
            Trending with your last score
          </p>
        ) : null}
      </div>
      {status === 'processing' ? (
        <Loader2 className="h-5 w-5 text-amber-400 animate-spin self-center mr-3 shrink-0" />
      ) : null}
    </Link>
  );
}
